import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IBaseRepository } from "@webapp/core/state-management/models/base-repository.model";
import { TodoGroups } from "../todos-widget.models";
import { TodosApiV2Service } from "./todos-api-v2.service";

@Injectable({ providedIn: "root" })
export class TodosRepository implements Pick<IBaseRepository<TodoGroups>, "getAll$"> {
  constructor(private api: TodosApiV2Service) {}

  public getAll$<TodoGroups>(): Observable<TodoGroups> {
    return this.api.getAll$<TodoGroups>();
  }
}
